// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-card-grid {
  display: grid;
  width: 100%;                
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); 
  gap: 26px;
}

.category-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px 28px;          /* ⬅ bigger card */
  min-height: 110px;           /* ⬅ hides empty space vertically */
  background: #fff;
  border-radius: 10px;
  width: 100%;                 /* ✅ card fills grid cell */
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);
}

.category-card img {
  width: 64px;
  height: 64px;
}

.category-card span {
  font-size: 16.5px;
  font-weight: 600;
}


/* Remove bootstrap max-width limitation */
.shop-category-fullwidth .container {
  max-width: 100% !important;
  padding-left: 24px;
  padding-right: 24px;
}

/* Apply sidebar offset ONLY for Shop By Categories page */
.shop-by-categories-page {
  padding-left: 240px; /* sidebar width */
}

/* Reset on mobile */
@media (max-width: 991px) {
  .shop-by-categories-page {
    padding-left: 0;
  }
}


`, "",{"version":3,"sources":["webpack://./src/Pages/supplier_app/ShopWiseCatalog/ShopByCategories.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB,WAAW,kBAAkB;EAC/C,iBAAiB,YAAY,mCAAmC;EAChE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW,kBAAkB,2BAA2B;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB,EAAE,kBAAkB;AACzC;;AAEA,oBAAoB;AACpB;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".category-card-grid {\n  display: grid;\n  width: 100%;                \n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); \n  gap: 26px;\n}\n\n.category-card {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 30px 28px;          /* ⬅ bigger card */\n  min-height: 110px;           /* ⬅ hides empty space vertically */\n  background: #fff;\n  border-radius: 10px;\n  width: 100%;                 /* ✅ card fills grid cell */\n}\n\n.category-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);\n}\n\n.category-card img {\n  width: 64px;\n  height: 64px;\n}\n\n.category-card span {\n  font-size: 16.5px;\n  font-weight: 600;\n}\n\n\n/* Remove bootstrap max-width limitation */\n.shop-category-fullwidth .container {\n  max-width: 100% !important;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n/* Apply sidebar offset ONLY for Shop By Categories page */\n.shop-by-categories-page {\n  padding-left: 240px; /* sidebar width */\n}\n\n/* Reset on mobile */\n@media (max-width: 991px) {\n  .shop-by-categories-page {\n    padding-left: 0;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
